const dessert = [
    {
        id: 1,
        name: 'Lemon cake',
        description: 'flour, sugar, baking powder, lemon',
        price: '9.80'
    },
    {
        id: 2,
        name: 'Cinnamon rolls',
        description: 'flour, salt, sugar, cinnamon, yeast, sour cream, milk',
        price: '11.75'
    },
    {
        id: 3,
        name: 'Vegan pancakes',
        description: 'flour, sugar, baking powder, soya milk, blueberries',
        price: '8.50'
    }
];

export default dessert;